module.exports = "/packs/004-a07bc116ff2d92ad02538d57dbe5ffb0.jpg";